import { Stack } from '@mui/material';
import type { CustomerOverview } from '@vy/api-definition';
import type { UseFormReturn } from 'react-hook-form';
import { FormProvider } from 'react-hook-form';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import type { AssignCustomerForm } from '../../types/assign-customer-dialog-form-types/assign-customer-form-schema';
import { ContractDateSection } from './ContractDateSection';
import { ContractTypeSection } from './ContractTypeSection';
import { CustomerSelectionSection } from './CustomerSelectionSection';

type CreateContractFormProps = {
  form: UseFormReturn<AssignCustomerForm>;
  customers: CustomerOverview[];
  onSubmit: () => void;
  onClose: () => void;
  isOpen: boolean;
  label: string;
  labelDescription: string;
};

export const CreateContractForm: React.FC<CreateContractFormProps> = ({
  form,
  customers,
  onSubmit,
  onClose,
  isOpen,
  label,
  labelDescription,
}) => {
  return (
    <VyDialog
      open={isOpen}
      allowPropagation
      label={label}
      labelDescription={labelDescription}
      ctaText="Next"
      cancelButtonText="Cancel"
      onSubmit={onSubmit}
      onClose={onClose}
      ctaButtonProps={{
        sx: {
          width: 166,
        },
      }}
      cancelButtonProps={{
        sx: {
          width: 94,
        },
      }}
      dialogContentProps={{
        style: {
          paddingTop: '20px',
        },
      }}
    >
      <FormProvider {...form}>
        <Stack direction="column" sx={{
          gap: 2
        }}>
          <CustomerSelectionSection customers={customers} />
          <ContractDateSection />
          <ContractTypeSection />
        </Stack>
      </FormProvider>
    </VyDialog>
  );
};
